<template>
  <div>
    <particlesHeader :Title="'Tools and Technologies'" :Size="13" />
    <section class="content-section">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="container">
              <div class="row floating-skills-container glass-background">
                <div class="col-md-4 floating-box-column no-up-bottom-margin">
                  <div class="backend-languages-box floating-box first-box-in-column">
                    <div class="inner-wrapper">
                      <div class="floating-box-header">
                        <img src="../assets/skills/backend.png" />
                        <span class="floating-box-header-text">Backend</span>
                      </div>
                      <ul class="floating-box-list">
                        <li>ASP.NET / Core</li>
                        <li>Node.JS</li>
                        <li>SQL Server</li>
                        <li>MySQL</li>
                        <!-- <li>PostgreSQL</li> -->
                        <li>MongoDB</li>
                        <li>IIS Server Management</li>
                        <!-- <li>Apache Server Management</li> -->
                        <!-- <li>Nginx Server Management</li> -->
                      </ul>
                    </div>
                  </div>
                  <div class="server-deployment-box floating-box">
                    <div class="inner-wrapper">
                      <div class="floating-box-header">
                        <img src="../assets/skills/deployment.png" />
                        <span class="floating-box-header-text">Deployment and Migrations</span>
                      </div>
                      <ul class="floating-box-list">
                        <li>Windows Remote Desktop</li>
                        <li>WinSCP</li>
                        <li>EF-Migration PS Scripts</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 floating-box-column no-up-bottom-margin">
                  <div class="frontend-languages-box floating-box first-box-in-column">
                    <div class="inner-wrapper">
                      <div class="floating-box-header">
                        <img src="../assets/skills/frontend.png" />
                        <span class="floating-box-header-text">Frontend</span>
                      </div>
                      <ul class="floating-box-list">
                        <li>Html</li>
                        <li>Css</li>
                        <li>Less</li>
                        <li>bootstrap</li>
                        <li>Javascript (es5 , es6)</li>
                        <li>Typescript (Js Babel)</li>
                        <li>Angular 2+</li>
                        <li>Vue JS</li>
                        <li>Three Js</li>
                      </ul>
                    </div>
                  </div>
                  <!-- <div class="design-tools-box floating-box">
                    <div class="inner-wrapper">
                      <div class="floating-box-header">
                        <img src="../assets/skills/design.png" />
                        <span class="floating-box-header-text">
                          Design
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </span>
                      </div>
                      <ul class="floating-box-list">
                        <li>Photoshop</li>
                        <li>Wix</li>
                      </ul>
                    </div>
                  </div> -->
                  <div class="animation-libraries-box floating-box">
                    <div class="inner-wrapper">
                      <div class="floating-box-header">
                        <img src="../assets/skills/animations.png" />
                        <span class="floating-box-header-text">Animation</span>
                      </div>
                      <ul class="floating-box-list">
                        <li>Velocity.JS</li>
                        <li>Animate.css</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="col-md-4 floating-box-column no-up-bottom-margin">
                  <div class="source-control-tools-box floating-box first-box-in-column">
                    <div class="inner-wrapper">
                      <div class="floating-box-header">
                        <img src="../assets/skills/source control.png" />
                        <span class="floating-box-header-text">Source Control</span>
                      </div>
                      <ul class="floating-box-list">
                        <li>Git</li>
                        <li>TFS</li>
                        <li>Source Tree</li>
                        <li>GitLens</li>
                      </ul>
                    </div>
                  </div>
                  <div class="office-tools-box floating-box">
                    <div class="inner-wrapper">
                      <div class="floating-box-header">
                        <img src="../assets/skills/office.png" />
                        <span class="floating-box-header-text">Office</span>
                      </div>
                      <ul class="floating-box-list">
                        <li>Microsoft Office</li>
                        <li>LibreOffice</li>
                        <li>Google Office Suite</li>
                      </ul>
                    </div>
                  </div>
                  <div class="testing-skills-box floating-box">
                    <div class="inner-wrapper">
                      <div class="floating-box-header">
                        <img src="../assets/skills/task.png" />
                        <span class="floating-box-header-text">Tasks Management</span>
                      </div>
                      <ul class="floating-box-list">
                        <li>Lean Testing</li>
                        <li>Airtables</li>
                        <li>TFS (Portal)</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <pageInlineNavigation :Next="'About'" :back="'Achievments'" />
    </section>
  </div>
</template>

<script>
import particlesHeader from "../components/particlesHeader";
import pageInlineNavigation from "../components/pageInlineNavigation";
export default {
  components: {
    particlesHeader,
    pageInlineNavigation,
  },

  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.skill-text {
  font-weight: bold;
  font-size: 20px;
}

.skill-container {
  margin: 15px;
}

.floating-skills-container {
  height: 500px;
}

.floating-box {
  text-align: center;
  padding: 10px;
  border: 2px solid #82828214;
}

.bordered-floating-box {
  border: 2px solid #82828214;
}

.floating-box-header {
  margin-bottom: 8px;
}

.floating-box-header img {
  width: 30px;
}

.floating-box-header-text {
  margin-left: 3px;
  color: #aacbec;
  font-weight: bold;
  font-size: 16px;
}

.floating-box-column {
  padding-left: 0px;
  padding-right: 0px;
}

.floating-box-list {
  list-style-type: none;
}

.floating-box-list li {
  font-size: 13px;
}

.backend-languages-box {
  height: 320px;
}

.server-deployment-box {
  height: 180px;
}

.frontend-languages-box {
  height: 245px;
}

.design-tools-box {
  height: 134px;
}

.animation-libraries-box {
  height: 121px;
}

.source-control-tools-box {
  height: 188px;
}

.office-tools-box {
  height: 166px;
}

.testing-skills-box {
  height: 146px;
}

.backend-languages-box {
  border-left: 0px solid white;
  border-top: 0px solid white;
}

.server-deployment-box {
  border-left: 0px solid white;
  border-bottom: 0px solid white;
}

.frontend-languages-box {
  border-top: 0px solid white;
}

.animation-libraries-box {
  border-bottom: 0px solid white;
}

.source-control-tools-box {
  border-right: 0px solid white;
  border-top: 0px solid white;
}

.office-tools-box {
  border-right: 0px solid white;
}

.testing-skills-box {
  border-right: 0px solid white;
  border-bottom: 0px solid white;
}

.first-box-in-column {
  padding-top: 20px;
}

@media (min-width: 481px) and (max-width: 767px),
  (min-width: 320px) and (max-width: 480px),
  (min-width: 768px) and (max-width: 1024px) {
  .first-box-in-column {
    padding-top: initial;
  }

  .floating-skills-container {
    height: initial;
  }

  .backend-languages-box {
    border-top: 0px solid red !important;
  }

  .floating-box-list {
    margin-top: 15px;
  }

  .floating-box-header img {
    width: 22px;
    margin-right: 10px;
  }

  .server-deployment-box {
    border-bottom: 4px solid #82828214;
  }

  .source-control-tools-box {
    border-top: 4px solid #82828214;
  }
}
</style>